import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { toast } from "sonner";
import "@/App.css";
import Landing from "@/pages/Landing";
import Studio from "@/pages/Studio";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import SetPage from "@/pages/SetPage";
import LivePage from "@/pages/LivePage";
import ProfilePage from "@/pages/ProfilePage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import AdminPage from "@/pages/AdminPage";
import LeaderboardPage from "@/pages/LeaderboardPage";
import SettingsPage from "@/pages/SettingsPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import DevicePage from "@/pages/DevicePage";
import TipPage from "@/pages/TipPage";
import WalletPage from "@/pages/WalletPage";
import HowToPage from "@/pages/HowToPage";
import DownloadPage from "@/pages/DownloadPage";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import HelpPage from "@/pages/HelpPage";
import { useAuth } from "@/context/AuthContext";
import { MidiProvider } from "@/context/MidiContext";
import { LinkProvider } from "@/context/LinkContext";
import ForcePasswordChangeModal from "@/components/ForcePasswordChangeModal";

function App() {
  const { loading } = useAuth();
  // Global toast for admin-triggered session invalidation
  useEffect(() => {
    const onExpired = () => toast.error("Signed out — your session was ended by an admin password reset. Please sign in again.");
    window.addEventListener("nd-session-expired", onExpired);
    return () => window.removeEventListener("nd-session-expired", onExpired);
  }, []);
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0B0E14] text-[#00F0FF] font-mono">
        <div className="neon-pulse" data-testid="app-loading">LOADING NEURALDECK…</div>
      </div>
    );
  }
  return (
    <div className="App grain">
      <BrowserRouter>
        <MidiProvider>
          <LinkProvider>
          <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/studio" element={<Studio />} />
          <Route path="/set/:id" element={<SetPage />} />
          <Route path="/live/:id" element={<LivePage />} />
          <Route path="/u/:id" element={<ProfilePage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/device" element={<DevicePage />} />
          <Route path="/tip/:handle" element={<TipPage />} />
          <Route path="/wallet" element={<WalletPage />} />
          <Route path="/how-to" element={<HowToPage />} />
          <Route path="/download" element={<DownloadPage />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/help" element={<HelpPage />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="*" element={<Navigate to="/" />} />
          </Routes>
          <ForcePasswordChangeModal/>
          </LinkProvider>
        </MidiProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
